
import { Component, Vue, Prop } from 'vue-property-decorator';
import SaplingGeneRepresentation from './SaplingGeneRepresentation.vue';

@Component({
  components: { SaplingGeneRepresentation }
})
export default class SaplingListNumbering extends Vue {
  @Prop({ type: Array, required: true }) readonly saplingGeneList!: string[];

  get showLegend() {
    return this.saplingGeneList && this.saplingGeneList.length > 0;
  }

  get showSpecial() {
    return this.saplingGeneList && this.saplingGeneList.length > 6;
  }
}
